import * as prismic from "@prismicio/client";

const endpoint = prismic.getRepositoryEndpoint("illinois-squeez");
const accessToken =
  "MC5hSGtaSkJFQUFDQUFBVUI4.dG_vv73vv70xW--_vWZ577-9VmHvv73vv73vv70YQBgeW3Hvv71GZhnvv73vv70lal9x77-9"; // Set an access token
const routes = [];

const client = prismic.createClient(endpoint, { routes, accessToken });

export default client;
